import React, { useContext } from 'react';
import { BaseRendererProps } from './eventRenderers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRepeat, faTurnUp } from '@fortawesome/free-solid-svg-icons';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import { getUniversalSourceIcon } from './StatChangeEvent';
import './RenderAggregatedCrowdControlEvent.css';

const RenderAggregatedCrowdControlEvent: React.FC<BaseRendererProps> = ({ log }) => {
  const { tickCount, ccType, duration, strength, source, sourceName, sourceChampionName, targetChampionName } = log.details;

  // Debug logging
  console.log('[DEBUG] RenderAggregatedCrowdControlEvent called with:', {
    logType: log.type,
    tickCount,
    ccType,
    duration,
    strength,
    source,
    sourceName,
    details: log.details
  });

  const { gameWideAssets, championsAssets } = useContext(GameAssetsContext);
  const { ccIcons } = gameWideAssets;

  const details = log.details;
  const sourceType = details.sourceType || 'Ability';
  const imageState = log.imageState;
  const championName = details.championName;
  const abilityKey = details.spellKey;

  // Get the CC icon - matches original CrowdControlEvent.tsx
  const ccIcon = ccIcons[ccType];

  // Use the universal source icon from StatChangeEvent
  const sourceIcon = getUniversalSourceIcon(
    {
      sourceType: sourceType,
      imageState: imageState,
      sourceName: sourceName || source,
      championName: championName,
      abilityKey: abilityKey,
    },
    gameWideAssets,
    championsAssets
  );

  // Format display text
  const durationText = duration ? `${duration.toFixed(1)}s` : '';
  const strengthText = strength !== undefined ? `-${Math.round(strength)}%` : '';
  const countText = tickCount > 1 ? `×${tickCount}` : '';
  
  // Tooltip text for hover
  const tooltipText = tickCount > 1 
    ? `${ccType}: Reapplied ${tickCount} times. \n${ccType} ${strengthText ? `${strengthText} ` : ''} for ${durationText}`
    : `${ccType}: ${durationText}${strengthText ? ` ${strengthText}` : ''}`;

  return (
    <div className="aggregated-cc-event" title={tooltipText}>
      {/* Main content area with icon and details */}
      <div className="cc-main-row">
        {/* CC Icon with repeat indicator underneath */}
        <div className="cc-icon-wrapper">
          {ccIcon ? (
            <img src={ccIcon} alt={ccType} className="cc-icon" />
          ) : (
            <div className="cc-icon-placeholder">{ccType}</div>
          )}
          {tickCount > 1 && (
            <div className="cc-repeat-badge">
              <FontAwesomeIcon icon={faRepeat} className="cc-repeat-icon" />
              <span className="cc-repeat-count">{tickCount}</span>
            </div>
          )}
        </div>

        {/* CC Details - matches original CrowdControlEvent structure */}
        <div className="cc-details">
          <span className="cc-type">{ccType}</span>
          {strengthText && <span className="cc-strength">{strengthText}</span>}
          {durationText && <span className="cc-duration">{durationText}</span>}
        </div>
      </div>

      {/* Source icon at bottom - only show if not an ability */}
      {sourceIcon && sourceType !== 'Ability' && (
        <div className="cc-source-wrapper">
          <FontAwesomeIcon icon={faTurnUp} className="fa-turn-up" />
          {sourceIcon}
        </div>
      )}
    </div>
  );
};

export default RenderAggregatedCrowdControlEvent; 